import { ApiError, type AuthUser } from "@kansai-ai-hub/api-client";
import type {
  LoginInput,
  PasswordResetConfirmInput,
  PasswordResetRequestInput,
} from "@kansai-ai-hub/schema";

import { apiClient } from "@/lib/api-client";

export async function fetchMe(): Promise<AuthUser | null> {
  try {
    const { user } = await apiClient.get<{ user: AuthUser }>("/api/v1/auth/me");
    return user;
  } catch (err) {
    if (err instanceof ApiError && err.isUnauthorized()) return null;
    throw err;
  }
}

export async function login(input: LoginInput): Promise<AuthUser> {
  const { user } = await apiClient.post<{ user: AuthUser }>("/api/v1/auth/login", {
    body: input,
  });
  return user;
}

export async function logout(): Promise<void> {
  await apiClient.post<void>("/api/v1/auth/logout");
}

// ── パスワード再設定（ENTERPRISE / MEMBER） ─────────────────────────────────

/**
 * 再設定メールの送信リクエスト。
 *
 * **成功と「該当なし」を区別できない**（サーバーは常に 202）。呼び出し側は
 * 入力されたアドレスの登録有無で画面を変えないこと —— 変えるとフォームが
 * メールアドレスの存在確認ツールになる。
 */
export async function requestPasswordReset(input: PasswordResetRequestInput): Promise<void> {
  await apiClient.post<void>("/api/v1/auth/password-reset/request", { body: input });
}

/** リンクを開いた直後の生死確認。**トークンは消費されない**（GET を使わないのも同じ理由）。 */
export async function verifyPasswordResetToken(token: string): Promise<boolean> {
  const { valid } = await apiClient.post<{ valid: boolean }>("/api/v1/auth/password-reset/verify", {
    body: { token },
  });
  return valid;
}

/** 新しいパスワードを確定する。成功しても**ログイン状態にはならない**（自動ログインしない）。 */
export async function confirmPasswordReset(input: PasswordResetConfirmInput): Promise<void> {
  await apiClient.post<void>("/api/v1/auth/password-reset/confirm", { body: input });
}
